import { render, staticRenderFns } from "./RealmCheckRows.vue?vue&type=template&id=56856376&scoped=true&"
import script from "./RealmCheckRows.vue?vue&type=script&lang=js&"
export * from "./RealmCheckRows.vue?vue&type=script&lang=js&"
import style0 from "./RealmCheckRows.vue?vue&type=style&index=0&id=56856376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56856376",
  null
  
)

export default component.exports